import React from 'react';
import { TableRow, TableCell, Checkbox, Select, MenuItem, TextField, IconButton, Tooltip, FormControlLabel } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

/**
 * קומפוננטה לוגית של שורה (Row) ב-TableBody.
 * מציגה ערכי עמודות, מצב עריכה או תצוגה, בחירה, איקון עריכה/מחיקה.
 */
const GenericTableRow = ({
  rowData,
  rowIndex,
  columns,
  columnWidths,
  isSelected,
  isEditable,
  hasLockedPermission,
  hasRequiredPermission,
  onRowClick,
  onRowSelect,
  onRowEdit,
  onRowDelete,
  onInputChange
}) => {
  return (
    <TableRow
      style={{
        backgroundColor: isSelected ? '#e0f7fa' : 'inherit',
        cursor: 'pointer',
        height: '40px',
        transition: 'background-color 0.3s'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.2)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = isSelected ? '#e0f7fa' : 'inherit';
      }}
      onClick={(e) => {
        if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'BUTTON') {
          onRowClick(rowData.id);
        }
      }}
    >
      {/* צ'קבוקס בחירה לשורה */}
      <TableCell style={{ minWidth: '50px', maxWidth: '50px', textAlign: 'center' }}>
        <Checkbox size="small" checked={isSelected} onChange={() => onRowSelect(rowData.id)} />
      </TableCell>

      {/* עמודות הדאטה */}
      {columns.map((column, colIndex) => (
        <TableCell key={colIndex} style={{ width: columnWidths[colIndex] }}>
          {isEditable ? (
            // במצב עריכה
            column.type === 'select' ? (
              <Select
                value={rowData[column.field]}
                onChange={(e) => onInputChange(rowIndex, column.field, e.target.value)}
                fullWidth
                size="small"
                disabled={
                  (rowData.locked && !hasLockedPermission()) ||
                  (rowData.required && !hasRequiredPermission())
                }
              >
                {column.options.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            ) : column.type === 'checkbox' ? (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={rowData[column.field]}
                    onChange={(e) => onInputChange(rowIndex, column.field, e.target.checked)}
                    disabled={rowData.locked && !hasLockedPermission()}
                  />
                }
                label={column.label}
              />
            ) : (
              <TextField
                type={column.inputType || 'text'}
                value={rowData[column.field]}
                onChange={(e) => onInputChange(rowIndex, column.field, e.target.value)}
                fullWidth
                size="small"
                disabled={
                  (rowData.locked && !hasLockedPermission()) ||
                  (rowData.required && !hasRequiredPermission())
                }
              />
            )
          ) : (
            // במצב תצוגה בלבד
              <div
                style={{
                  maxWidth: columnWidths[colIndex] + 10,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  paddingLeft: 0
                }}>
                {rowData[column.field]}
              </div>
          )}
        </TableCell>
      ))}

      {/* כפתור עריכה */}
      <TableCell style={{ minWidth: '50px', maxWidth: '50px', textAlign: 'center' }}>
        <Tooltip title="עריכה">
          <IconButton onClick={() => onRowEdit(rowIndex)}>
            <EditIcon style={{ color: 'lightblue' }} />
          </IconButton>
        </Tooltip>
      </TableCell>

      {/* כפתור מחיקה */}
      <TableCell style={{ minWidth: '50px', maxWidth: '50px', textAlign: 'center' }}>
        <Tooltip
          title={
            rowData.locked
              ? hasLockedPermission()
                ? 'הסר למרות שנעול'
                : 'רשומה נעולה, לא ניתן למחוק'
              : rowData.required
              ? hasRequiredPermission()
                ? 'הסר למרות שחובה'
                : 'רשומת חובה, לא ניתן למחוק'
              : 'מחיקה'
          }
        >
          <span>
            <IconButton onClick={() => onRowDelete(rowIndex)} disabled={
              rowData.locked && (!hasLockedPermission() || !hasRequiredPermission())
            }>
              <DeleteIcon
                color={
                  (rowData.locked && !hasLockedPermission()) ||
                  (rowData.required && !hasRequiredPermission())
                    ? 'disabled'
                    : 'error'
                }
              />
            </IconButton>
          </span>
        </Tooltip>
      </TableCell>

      {/* Spacer */}
      <TableCell style={{ width: '100%' }} />
    </TableRow>
  );
};

export default GenericTableRow;
